// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api_proto/v1/file.proto (package api_proto.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api_proto/v1/file.proto.
 */
export const file_api_proto_v1_file: GenFile = /*@__PURE__*/
  fileDesc("ChdhcGlfcHJvdG8vdjEvZmlsZS5wcm90bxIMYXBpX3Byb3RvLnYxIikKBlVwbG9hZBIRCglmaWxlX25hbWUYASABKAkSDAoEZGF0YRgEIAEoDCI3ChFVcGxvYWRGaWxlUmVxdWVzdBIiCgRmaWxlGAEgASgLMhQuYXBpX3Byb3RvLnYxLlVwbG9hZCJIChJVcGxvYWRGaWxlUmVzcG9uc2USEAoIZmlsZV91cmwYASABKAkSFAoMY29udGVudF90eXBlGAIgASgJEgoKAmlkGAMgASgDQjNaMWdpdGh1Yi5jb20vaC1zY2FwZS9pZXNhcHVyaS9nby9hcGlfcHJvdG8vdjE7YXBpdjFiBnByb3RvMw");

/**
 * FileUploadのリクエストモデル
 *
 * @generated from message api_proto.v1.Upload
 */
export type Upload = Message<"api_proto.v1.Upload"> & {
  /**
   * @generated from field: string file_name = 1;
   */
  fileName: string;

  /**
   * @generated from field: bytes data = 4;
   */
  data: Uint8Array;
};

/**
 * Describes the message api_proto.v1.Upload.
 * Use `create(UploadSchema)` to create a new message.
 */
export const UploadSchema: GenMessage<Upload> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_file, 0);

/**
 * @generated from message api_proto.v1.UploadFileRequest
 */
export type UploadFileRequest = Message<"api_proto.v1.UploadFileRequest"> & {
  /**
   * @generated from field: api_proto.v1.Upload file = 1;
   */
  file?: Upload;
};

/**
 * Describes the message api_proto.v1.UploadFileRequest.
 * Use `create(UploadFileRequestSchema)` to create a new message.
 */
export const UploadFileRequestSchema: GenMessage<UploadFileRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_file, 1);

/**
 * @generated from message api_proto.v1.UploadFileResponse
 */
export type UploadFileResponse = Message<"api_proto.v1.UploadFileResponse"> & {
  /**
   * @generated from field: string file_url = 1;
   */
  fileUrl: string;

  /**
   * @generated from field: string content_type = 2;
   */
  contentType: string;

  /**
   * @generated from field: int64 id = 3;
   */
  id: bigint;
};

/**
 * Describes the message api_proto.v1.UploadFileResponse.
 * Use `create(UploadFileResponseSchema)` to create a new message.
 */
export const UploadFileResponseSchema: GenMessage<UploadFileResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_file, 2);

